var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcShareFacebookLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#4285F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0826 33.5497L38.8082 28.772H34.2694V25.673C34.2694 24.3656 34.9023 23.0905 36.9352 23.0905H39V19.023C39 19.023 37.1269 18.7002 35.337 18.7002C31.5973 18.7002 29.1553 20.989 29.1553 25.1307V28.772H25V33.5497H29.1553V45.1C29.9895 45.2324 30.8429 45.3002 31.7123 45.3002C32.5817 45.3002 33.4352 45.2324 34.2694 45.1V33.5497H38.0826Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShareFacebookLarge);
export default __webpack_public_path__ + "static/media/ic_share_facebook_large.5eda713415514b6d0c0d35fdcb3bd27c.svg";
export { ForwardRef as ReactComponent };